import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/friseMonParcours.svg'


const _withScopeId = n => (_pushScopeId("data-v-096be054"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "monParcours",
  class: "flex w-screen"
}
const _hoisted_2 = { class: "titleSection ml-10" }
const _hoisted_3 = { class: "flex w-full h-2/3 my-auto ml-32 text-xl" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-between mr-3 font-medium" }, [
  /*#__PURE__*/_createElementVNode("p", null, "2023"),
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("p", null, "2020"),
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("p", null, "2019"),
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("p", null, "2017"),
  /*#__PURE__*/_createElementVNode("p")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = { class: "flex flex-col justify-between ml-3 text-2xl" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('header.sommaire.1')), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('monParcour.frise.ecoleIngenieur')), 1),
        _hoisted_8,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('monParcour.frise.licencePro')), 1),
        _hoisted_9,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('monParcour.frise.dutMMI')), 1),
        _hoisted_10,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('monParcour.frise.bacSSVT')), 1)
      ])
    ])
  ]))
}